<template>
  <div id="userdw">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'userdw'
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/member/user/company/Userdw.vue